import { render, staticRenderFns } from "./modal-login.vue?vue&type=template&id=83c50568&scoped=true&"
import script from "./modal-login.ts?vue&type=script&lang=ts&"
export * from "./modal-login.ts?vue&type=script&lang=ts&"
import style0 from "./modal-login.scss?vue&type=style&index=0&id=83c50568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c50568",
  null
  
)

export default component.exports